import React, { useEffect, useState } from "react";
import { Outlet, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faShoppingCart,
  faLeaf,
  faCog,
  faBell,
} from "@fortawesome/free-solid-svg-icons";

import Sidebar from "./Sidebar";
//import NotificationBadge from '../components/NotificationBadge';
import "./Navigation.css";
const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const cartItems = useSelector((state) => state.chariot);
  //const notifications = useSelector((state) => state.notifications.count);
  const user = useSelector((state) => state.user);
  const logCli = useSelector((state) => state.client);
  const { client, erreur, loading } = logCli;
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  useEffect(() => {
    console.log(cartItems);
  }, []);
  return (
    <div className="app-container-nav">
      {/* }
      <Sidebar
        isOpen={sidebarOpen}
        onClose={toggleSidebar}
        user={client.nom_cli}
      />*/}

      {/* Main Content */}
      <div className="main-content-nav">
        {/* Top Navigation Bar */}
        <nav className="top-nav-nav">
          <button className="menu-button-nav" onClick={toggleSidebar}>
            ☰
          </button>
          <h1 className="app-title-nav">
            {client.nivcli_cloud == "A"
              ? "Admin:" + client.nom_cli
              : "Client:" + client.nom_cli}
          </h1>
          {/*<div className="notifications">
            <Link to="/notifications">
              <FontAwesomeIcon icon={faBell} />
              {notifications > 0 && <NotificationBadge count={notifications} />}
            </Link>
          </div>*/}
        </nav>

        {/* Page Content */}
        <div className="page-content-nav">
          <Outlet />
        </div>
        {/* Bottom Tab Navigation */}
        <nav className="bottom-tabs-nav">
          <Link to="/" className="tab-item-nav">
            <FontAwesomeIcon icon={faHome} />
            <span>Acceuil</span>
          </Link>
          <Link to="/articles" className="tab-item-nav">
            <FontAwesomeIcon icon={faLeaf} />
            <span>Articles</span>
          </Link>
          <Link to="/chariot" className="tab-item-nav">
            <FontAwesomeIcon icon={faShoppingCart} />
            {cartItems?.chariotListe.length > 0 && (
              <span className="cart-badge-nav">
                {cartItems?.chariotListe.length}
              </span>
            )}
            <span>Cart</span>
          </Link>
          {user?.role === "admin" && (
            <Link to="/admin" className="tab-item-nav">
              <FontAwesomeIcon icon={faCog} />
              <span>Admin</span>
            </Link>
          )}
        </nav>
      </div>
    </div>
  );
};

export default MainLayout;
